export const features = [
  { title: "Высокая скорость", text: "Вывозим каждый день. Есть срочный вывоз." },
  { title: "Бесплатная погрузка", text: "Сами спустим и погрузим. Ручной спуск до 5 этажа включён." },
  { title: "Фиксированная стоимость", text: "Согласуем цену до заявки и фиксируем до выполнения." },
  { title: "Аккуратная команда", text: "Разберём, вынесем и вывезем бережно." },
];

export const popularServices = [
  { name: "Стиральная машина", tag: "Бытовая техника" },
  { name: "Холодильник", tag: "Бытовая техника" },
  { name: "Газовая плита", tag: "Бытовая техника" },
  { name: "Старый диван", tag: "Мебель" },
  { name: "Матрас", tag: "Мебель" },
  { name: "Металлическая дверь", tag: "Металл" },
  { name: "Чугунная ванна", tag: "Металл" },
];

export const stats = [
  { value: "2018", label: "Год основания" },
  { value: "170+", label: "Городов в РФ" },
  { value: "703 800", label: "Выполнено заказов" },
];

export const reviews = [
  { name: "Наталья", text: "Приехали в точное время, оперативно всё забрали. Спасибо!" },
  { name: "Сергей", text: "Профессионально, аккуратно, в согласованный срок." },
  { name: "Елена", text: "Очень оперативно! Забрали через 30 минут после звонка." },
];
